module.exports = __webpack_public_path__ + "img/hr-tree-02-a-leaves.165205c6.png";